
import { Component, Vue } from "vue-property-decorator";
import { AppModule } from "@/store/modules/app";
import { PermissionModule } from "@/store/modules/permission";
import { SettingsModule } from "@/store/modules/settings";
import SidebarOne from "./sideBarThems/SidebarOne.vue";
import SidebarTwo from "./sideBarThems/SidebarTwo.vue";
import SidebarLogo from "./SidebarLogo.vue";
import variables from "@/styles/_variables.scss";

@Component({
    name: "SideBar",
    components: {
        SidebarOne,
        SidebarLogo,
        SidebarTwo,
    },
})
export default class extends Vue {
    private sidebarItem: string = "";

    get sidebar() {
        return AppModule.sidebar;
    }

    get routes() {
        return PermissionModule.dynamicRoutes;
    }

    get showLogo() {
        return SettingsModule.showSidebarLogo;
    }

    get menuActiveTextColor() {
        if (SettingsModule.sidebarTextTheme) {
            return SettingsModule.theme;
        } else {
            return variables.menuActiveText;
        }
    }

    get sidebarThem() {
        return SettingsModule.showSidebarTheme;
    }

    get variables() {
        return variables;
    }

    get activeMenu() {
        const route = this.$route;
        const { meta, path } = route;
        // if set path, the sidebar will highlight the path you set
        if (meta?.activeMenu) {
            return meta.activeMenu;
        }
        return path;
    }

    get isCollapse() {
        return !this.sidebar.opened;
    }
}
